/** Mock coverage for UK postcode areas (public/geo/uk-postcode-areas.json). */
export type UkMapRegionMetric = {
  id: string;
  label: string;
  firms: string;
  coverage: string;
  coveragePercent: number;
  /** Postcode area drawn on the map, e.g. WV. */
  postcode: string;
  /** Pixel size so the code fits the area. */
  labelSize: number;
  lat: number;
  lon: number;
};

export const UK_MAP_REGION_METRICS: UkMapRegionMetric[] = [
  {
    id: 'AB',
    label: 'Aberdeen',
    firms: '41k',
    coverage: '51%',
    coveragePercent: 51,
    postcode: 'AB',
    labelSize: 16,
    lat: 57.284,
    lon: -2.6987
  },
  {
    id: 'AL',
    label: 'St Albans',
    firms: '31k',
    coverage: '19%',
    coveragePercent: 19,
    postcode: 'AL',
    labelSize: 9,
    lat: 51.7817,
    lon: -0.2953
  },
  {
    id: 'B',
    label: 'Birmingham',
    firms: '46k',
    coverage: '38%',
    coveragePercent: 38,
    postcode: 'B',
    labelSize: 11,
    lat: 52.4246,
    lon: -1.853
  },
  {
    id: 'BA',
    label: 'Bath',
    firms: '41k',
    coverage: '51%',
    coveragePercent: 51,
    postcode: 'BA',
    labelSize: 12,
    lat: 51.1816,
    lon: -2.4136
  },
  {
    id: 'BB',
    label: 'Blackburn',
    firms: '44k',
    coverage: '24%',
    coveragePercent: 24,
    postcode: 'BB',
    labelSize: 11,
    lat: 53.8416,
    lon: -2.3531
  },
  {
    id: 'BD',
    label: 'Bradford',
    firms: '10k',
    coverage: '38%',
    coveragePercent: 38,
    postcode: 'BD',
    labelSize: 12,
    lat: 54.0024,
    lon: -2.0472
  },
  {
    id: 'BH',
    label: 'Bournemouth',
    firms: '22k',
    coverage: '32%',
    coveragePercent: 32,
    postcode: 'BH',
    labelSize: 11,
    lat: 50.7685,
    lon: -1.9486
  },
  {
    id: 'BL',
    label: 'Bolton',
    firms: '34k',
    coverage: '26%',
    coveragePercent: 26,
    postcode: 'BL',
    labelSize: 9,
    lat: 53.6093,
    lon: -2.4161
  },
  {
    id: 'BN',
    label: 'Brighton',
    firms: '40k',
    coverage: '40%',
    coveragePercent: 40,
    postcode: 'BN',
    labelSize: 11,
    lat: 50.8645,
    lon: -0.0849
  },
  {
    id: 'BR',
    label: 'Bromley',
    firms: '12k',
    coverage: '34%',
    coveragePercent: 34,
    postcode: 'BR',
    labelSize: 9,
    lat: 51.3826,
    lon: 0.0679
  },
  {
    id: 'BS',
    label: 'Bristol',
    firms: '15k',
    coverage: '41%',
    coveragePercent: 41,
    postcode: 'BS',
    labelSize: 11,
    lat: 51.4154,
    lon: -2.6599
  },
  {
    id: 'BT',
    label: 'Belfast',
    firms: '18k',
    coverage: '48%',
    coveragePercent: 48,
    postcode: 'BT',
    labelSize: 19,
    lat: 54.6087,
    lon: -6.6909
  },
  {
    id: 'CA',
    label: 'Carlisle',
    firms: '44k',
    coverage: '24%',
    coveragePercent: 24,
    postcode: 'CA',
    labelSize: 14,
    lat: 54.7006,
    lon: -2.8942
  },
  {
    id: 'CB',
    label: 'Cambridge',
    firms: '47k',
    coverage: '31%',
    coveragePercent: 31,
    postcode: 'CB',
    labelSize: 12,
    lat: 52.2179,
    lon: 0.2467
  },
  {
    id: 'CF',
    label: 'Cardiff',
    firms: '19k',
    coverage: '25%',
    coveragePercent: 25,
    postcode: 'CF',
    labelSize: 11,
    lat: 51.5932,
    lon: -3.4129
  },
  {
    id: 'CH',
    label: 'Chester',
    firms: '25k',
    coverage: '39%',
    coveragePercent: 39,
    postcode: 'CH',
    labelSize: 11,
    lat: 53.2263,
    lon: -3.029
  },
  {
    id: 'CM',
    label: 'Chelmsford',
    firms: '40k',
    coverage: '40%',
    coveragePercent: 40,
    postcode: 'CM',
    labelSize: 12,
    lat: 51.7678,
    lon: 0.4482
  },
  {
    id: 'CO',
    label: 'Colchester',
    firms: '46k',
    coverage: '20%',
    coveragePercent: 20,
    postcode: 'CO',
    labelSize: 11,
    lat: 51.9398,
    lon: 0.8506
  },
  {
    id: 'CR',
    label: 'Croydon',
    firms: '15k',
    coverage: '41%',
    coveragePercent: 41,
    postcode: 'CR',
    labelSize: 9,
    lat: 51.3302,
    lon: -0.0806
  },
  {
    id: 'CT',
    label: 'Canterbury',
    firms: '21k',
    coverage: '21%',
    coveragePercent: 21,
    postcode: 'CT',
    labelSize: 10,
    lat: 51.2337,
    lon: 1.1857
  },
  {
    id: 'CV',
    label: 'Coventry',
    firms: '27k',
    coverage: '35%',
    coveragePercent: 35,
    postcode: 'CV',
    labelSize: 12,
    lat: 52.3325,
    lon: -1.5043
  },
  {
    id: 'CW',
    label: 'Crewe',
    firms: '30k',
    coverage: '42%',
    coveragePercent: 42,
    postcode: 'CW',
    labelSize: 11,
    lat: 53.1393,
    lon: -2.4773
  },
  {
    id: 'DA',
    label: 'Dartford',
    firms: '47k',
    coverage: '31%',
    coveragePercent: 31,
    postcode: 'DA',
    labelSize: 9,
    lat: 51.4164,
    lon: 0.2681
  },
  {
    id: 'DD',
    label: 'Dundee',
    firms: '16k',
    coverage: '18%',
    coveragePercent: 18,
    postcode: 'DD',
    labelSize: 12,
    lat: 56.7202,
    lon: -2.861
  },
  {
    id: 'DE',
    label: 'Derby',
    firms: '19k',
    coverage: '25%',
    coveragePercent: 25,
    postcode: 'DE',
    labelSize: 11,
    lat: 52.9613,
    lon: -1.5838
  },
  {
    id: 'DG',
    label: 'Dumfries',
    firms: '25k',
    coverage: '39%',
    coveragePercent: 39,
    postcode: 'DG',
    labelSize: 16,
    lat: 55.0787,
    lon: -3.9677
  },
  {
    id: 'DH',
    label: 'Durham',
    firms: '28k',
    coverage: '46%',
    coveragePercent: 46,
    postcode: 'DH',
    labelSize: 10,
    lat: 54.8204,
    lon: -1.7203
  },
  {
    id: 'DL',
    label: 'Darlington',
    firms: '40k',
    coverage: '40%',
    coveragePercent: 40,
    postcode: 'DL',
    labelSize: 13,
    lat: 54.4956,
    lon: -1.8556
  },
  {
    id: 'DN',
    label: 'Doncaster',
    firms: '46k',
    coverage: '20%',
    coveragePercent: 20,
    postcode: 'DN',
    labelSize: 13,
    lat: 53.5377,
    lon: -0.7266
  },
  {
    id: 'DT',
    label: 'Dorchester',
    firms: '24k',
    coverage: '28%',
    coveragePercent: 28,
    postcode: 'DT',
    labelSize: 12,
    lat: 50.7988,
    lon: -2.4673
  },
  {
    id: 'DY',
    label: 'Dudley',
    firms: '39k',
    coverage: '29%',
    coveragePercent: 29,
    postcode: 'DY',
    labelSize: 10,
    lat: 52.4135,
    lon: -2.291
  },
  {
    id: 'E',
    label: 'East London',
    firms: '15k',
    coverage: '25%',
    coveragePercent: 25,
    postcode: 'E',
    labelSize: 9,
    lat: 51.5602,
    lon: -0.0012
  },
  {
    id: 'EC',
    label: 'East Central London',
    firms: '16k',
    coverage: '18%',
    coveragePercent: 18,
    postcode: 'EC',
    labelSize: 8,
    lat: 51.518,
    lon: -0.0957
  },
  {
    id: 'EH',
    label: 'Edinburgh',
    firms: '31k',
    coverage: '19%',
    coveragePercent: 19,
    postcode: 'EH',
    labelSize: 13,
    lat: 55.837,
    lon: -3.1547
  },
  {
    id: 'EN',
    label: 'Enfield',
    firms: '9k',
    coverage: '27%',
    coveragePercent: 27,
    postcode: 'EN',
    labelSize: 9,
    lat: 51.6946,
    lon: -0.0922
  },
  {
    id: 'EX',
    label: 'Exeter',
    firms: '39k',
    coverage: '29%',
    coveragePercent: 29,
    postcode: 'EX',
    labelSize: 14,
    lat: 50.8742,
    lon: -3.8247
  },
  {
    id: 'FK',
    label: 'Falkirk',
    firms: '43k',
    coverage: '47%',
    coveragePercent: 47,
    postcode: 'FK',
    labelSize: 13,
    lat: 56.2416,
    lon: -4.1909
  },
  {
    id: 'FY',
    label: 'Blackpool',
    firms: '45k',
    coverage: '43%',
    coveragePercent: 43,
    postcode: 'FY',
    labelSize: 9,
    lat: 53.8312,
    lon: -2.9923
  },
  {
    id: 'G',
    label: 'Glasgow',
    firms: '21k',
    coverage: '39%',
    coveragePercent: 39,
    postcode: 'G',
    labelSize: 13,
    lat: 55.9939,
    lon: -4.4295
  },
  {
    id: 'GL',
    label: 'Gloucester',
    firms: '9k',
    coverage: '27%',
    coveragePercent: 27,
    postcode: 'GL',
    labelSize: 13,
    lat: 51.8195,
    lon: -2.1259
  },
  {
    id: 'GU',
    label: 'Guildford',
    firms: '36k',
    coverage: '22%',
    coveragePercent: 22,
    postcode: 'GU',
    labelSize: 11,
    lat: 51.1421,
    lon: -0.7484
  },
  {
    id: 'GY',
    label: 'Guernsey',
    firms: '8k',
    coverage: '50%',
    coveragePercent: 50,
    postcode: 'GY',
    labelSize: 9,
    lat: 49.4586,
    lon: -2.5803
  },
  {
    id: 'HA',
    label: 'Harrow',
    firms: '19k',
    coverage: '25%',
    coveragePercent: 25,
    postcode: 'HA',
    labelSize: 9,
    lat: 51.5881,
    lon: -0.3517
  },
  {
    id: 'HD',
    label: 'Huddersfield',
    firms: '28k',
    coverage: '46%',
    coveragePercent: 46,
    postcode: 'HD',
    labelSize: 10,
    lat: 53.6046,
    lon: -1.7948
  },
  {
    id: 'HG',
    label: 'Harrogate',
    firms: '37k',
    coverage: '33%',
    coveragePercent: 33,
    postcode: 'HG',
    labelSize: 11,
    lat: 54.1031,
    lon: -1.6532
  },
  {
    id: 'HP',
    label: 'Hemel Hempstead',
    firms: '24k',
    coverage: '28%',
    coveragePercent: 28,
    postcode: 'HP',
    labelSize: 11,
    lat: 51.7527,
    lon: -0.7656
  },
  {
    id: 'HR',
    label: 'Hereford',
    firms: '30k',
    coverage: '42%',
    coveragePercent: 42,
    postcode: 'HR',
    labelSize: 12,
    lat: 52.0813,
    lon: -2.7863
  },
  {
    id: 'HS',
    label: 'Outer Hebrides',
    firms: '33k',
    coverage: '49%',
    coveragePercent: 49,
    postcode: 'HS',
    labelSize: 13,
    lat: 58.1323,
    lon: -6.6608
  },
  {
    id: 'HU',
    label: 'Hull',
    firms: '39k',
    coverage: '29%',
    coveragePercent: 29,
    postcode: 'HU',
    labelSize: 11,
    lat: 53.7809,
    lon: -0.2903
  },
  {
    id: 'HX',
    label: 'Halifax',
    firms: '8k',
    coverage: '50%',
    coveragePercent: 50,
    postcode: 'HX',
    labelSize: 9,
    lat: 53.722,
    lon: -1.9519
  },
  {
    id: 'IG',
    label: 'Ilford',
    firms: '40k',
    coverage: '40%',
    coveragePercent: 40,
    postcode: 'IG',
    labelSize: 9,
    lat: 51.6038,
    lon: 0.0768
  },
  {
    id: 'IM',
    label: 'Isle of Man',
    firms: '18k',
    coverage: '48%',
    coveragePercent: 48,
    postcode: 'IM',
    labelSize: 10,
    lat: 54.2252,
    lon: -4.5394
  },
  {
    id: 'IP',
    label: 'Ipswich',
    firms: '27k',
    coverage: '35%',
    coveragePercent: 35,
    postcode: 'IP',
    labelSize: 14,
    lat: 52.277,
    lon: 1.0296
  },
  {
    id: 'IV',
    label: 'Inverness',
    firms: '45k',
    coverage: '43%',
    coveragePercent: 43,
    postcode: 'IV',
    labelSize: 20,
    lat: 57.7374,
    lon: -4.7209
  },
  {
    id: 'JE',
    label: 'Jersey',
    firms: '37k',
    coverage: '33%',
    coveragePercent: 33,
    postcode: 'JE',
    labelSize: 9,
    lat: 49.2151,
    lon: -2.132
  },
  {
    id: 'KA',
    label: 'Kilmarnock',
    firms: '28k',
    coverage: '46%',
    coveragePercent: 46,
    postcode: 'KA',
    labelSize: 14,
    lat: 55.4351,
    lon: -4.5344
  },
  {
    id: 'KT',
    label: 'Kingston upon Thames',
    firms: '45k',
    coverage: '43%',
    coveragePercent: 43,
    postcode: 'KT',
    labelSize: 10,
    lat: 51.3354,
    lon: -0.3659
  },
  {
    id: 'KW',
    label: 'Kirkwall',
    firms: '14k',
    coverage: '30%',
    coveragePercent: 30,
    postcode: 'KW',
    labelSize: 14,
    lat: 58.3651,
    lon: -3.7308
  },
  {
    id: 'KY',
    label: 'Kirkcaldy',
    firms: '20k',
    coverage: '44%',
    coveragePercent: 44,
    postcode: 'KY',
    labelSize: 12,
    lat: 56.221,
    lon: -3.1625
  },
  {
    id: 'L',
    label: 'Liverpool',
    firms: '36k',
    coverage: '40%',
    coveragePercent: 40,
    postcode: 'L',
    labelSize: 10,
    lat: 53.498,
    lon: -2.9088
  },
  {
    id: 'LA',
    label: 'Lancaster',
    firms: '31k',
    coverage: '19%',
    coveragePercent: 19,
    postcode: 'LA',
    labelSize: 13,
    lat: 54.241,
    lon: -2.8096
  },
  {
    id: 'LD',
    label: 'Llandrindod Wells',
    firms: '40k',
    coverage: '40%',
    coveragePercent: 40,
    postcode: 'LD',
    labelSize: 12,
    lat: 52.1533,
    lon: -3.3933
  },
  {
    id: 'LE',
    label: 'Leicester',
    firms: '43k',
    coverage: '47%',
    coveragePercent: 47,
    postcode: 'LE',
    labelSize: 12,
    lat: 52.6468,
    lon: -1.0227
  },
  {
    id: 'LL',
    label: 'Llandudno',
    firms: '24k',
    coverage: '28%',
    coveragePercent: 28,
    postcode: 'LL',
    labelSize: 15,
    lat: 53.0445,
    lon: -3.8495
  },
  {
    id: 'LN',
    label: 'Lincoln',
    firms: '30k',
    coverage: '42%',
    coveragePercent: 42,
    postcode: 'LN',
    labelSize: 12,
    lat: 53.2752,
    lon: -0.2632
  },
  {
    id: 'LS',
    label: 'Leeds',
    firms: '45k',
    coverage: '43%',
    coveragePercent: 43,
    postcode: 'LS',
    labelSize: 11,
    lat: 53.8622,
    lon: -1.492
  },
  {
    id: 'LU',
    label: 'Luton',
    firms: '11k',
    coverage: '23%',
    coveragePercent: 23,
    postcode: 'LU',
    labelSize: 9,
    lat: 51.8979,
    lon: -0.5529
  },
  {
    id: 'M',
    label: 'Manchester',
    firms: '39k',
    coverage: '47%',
    coveragePercent: 47,
    postcode: 'M',
    labelSize: 10,
    lat: 53.4816,
    lon: -2.3008
  },
  {
    id: 'ME',
    label: 'Medway',
    firms: '46k',
    coverage: '20%',
    coveragePercent: 20,
    postcode: 'ME',
    labelSize: 10,
    lat: 51.3266,
    lon: 0.6518
  },
  {
    id: 'MK',
    label: 'Milton Keynes',
    firms: '24k',
    coverage: '28%',
    coveragePercent: 28,
    postcode: 'MK',
    labelSize: 11,
    lat: 52.0755,
    lon: -0.6656
  },
  {
    id: 'ML',
    label: 'Motherwell',
    firms: '27k',
    coverage: '35%',
    coveragePercent: 35,
    postcode: 'ML',
    labelSize: 12,
    lat: 55.6284,
    lon: -3.7615
  },
  {
    id: 'N',
    label: 'North London',
    firms: '42k',
    coverage: '20%',
    coveragePercent: 20,
    postcode: 'N',
    labelSize: 9,
    lat: 51.5973,
    lon: -0.1173
  },
  {
    id: 'NE',
    label: 'Newcastle upon Tyne',
    firms: '9k',
    coverage: '27%',
    coveragePercent: 27,
    postcode: 'NE',
    labelSize: 14,
    lat: 55.1987,
    lon: -2.0106
  },
  {
    id: 'NG',
    label: 'Nottingham',
    firms: '15k',
    coverage: '41%',
    coveragePercent: 41,
    postcode: 'NG',
    labelSize: 12,
    lat: 53.0079,
    lon: -0.8429
  },
  {
    id: 'NN',
    label: 'Northampton',
    firms: '36k',
    coverage: '22%',
    coveragePercent: 22,
    postcode: 'NN',
    labelSize: 12,
    lat: 52.2804,
    lon: -0.8927
  },
  {
    id: 'NP',
    label: 'Newport',
    firms: '42k',
    coverage: '36%',
    coveragePercent: 36,
    postcode: 'NP',
    labelSize: 11,
    lat: 51.7444,
    lon: -2.9695
  },
  {
    id: 'NR',
    label: 'Norwich',
    firms: '8k',
    coverage: '50%',
    coveragePercent: 50,
    postcode: 'NR',
    labelSize: 13,
    lat: 52.6706,
    lon: 1.2509
  },
  {
    id: 'NW',
    label: 'North West London',
    firms: '23k',
    coverage: '51%',
    coveragePercent: 51,
    postcode: 'NW',
    labelSize: 9,
    lat: 51.5689,
    lon: -0.2161
  },
  {
    id: 'OL',
    label: 'Oldham',
    firms: '33k',
    coverage: '49%',
    coveragePercent: 49,
    postcode: 'OL',
    labelSize: 10,
    lat: 53.6173,
    lon: -2.102
  },
  {
    id: 'OX',
    label: 'Oxford',
    firms: '29k',
    coverage: '31%',
    coveragePercent: 31,
    postcode: 'OX',
    labelSize: 12,
    lat: 51.8144,
    lon: -1.3244
  },
  {
    id: 'PA',
    label: 'Paisley',
    firms: '43k',
    coverage: '47%',
    coveragePercent: 47,
    postcode: 'PA',
    labelSize: 15,
    lat: 56.1182,
    lon: -5.2718
  },
  {
    id: 'PE',
    label: 'Peterborough',
    firms: '15k',
    coverage: '41%',
    coveragePercent: 41,
    postcode: 'PE',
    labelSize: 15,
    lat: 52.7022,
    lon: 0.0492
  },
  {
    id: 'PH',
    label: 'Perth',
    firms: '24k',
    coverage: '28%',
    coveragePercent: 28,
    postcode: 'PH',
    labelSize: 19,
    lat: 56.8099,
    lon: -4.3568
  },
  {
    id: 'PL',
    label: 'Plymouth',
    firms: '36k',
    coverage: '22%',
    coveragePercent: 22,
    postcode: 'PL',
    labelSize: 13,
    lat: 50.4977,
    lon: -4.4153
  },
  {
    id: 'PO',
    label: 'Portsmouth',
    firms: '45k',
    coverage: '43%',
    coveragePercent: 43,
    postcode: 'PO',
    labelSize: 10,
    lat: 50.8591,
    lon: -0.9335
  },
  {
    id: 'PR',
    label: 'Preston',
    firms: '14k',
    coverage: '30%',
    coveragePercent: 30,
    postcode: 'PR',
    labelSize: 11,
    lat: 53.774,
    lon: -2.7512
  },
  {
    id: 'RG',
    label: 'Reading',
    firms: '27k',
    coverage: '35%',
    coveragePercent: 35,
    postcode: 'RG',
    labelSize: 12,
    lat: 51.3952,
    lon: -1.1378
  },
  {
    id: 'RH',
    label: 'Redhill',
    firms: '30k',
    coverage: '42%',
    coveragePercent: 42,
    postcode: 'RH',
    labelSize: 11,
    lat: 51.0892,
    lon: -0.2563
  },
  {
    id: 'RM',
    label: 'Romford',
    firms: '45k',
    coverage: '43%',
    coveragePercent: 43,
    postcode: 'RM',
    labelSize: 10,
    lat: 51.5497,
    lon: 0.2464
  },
  {
    id: 'S',
    label: 'Sheffield',
    firms: '17k',
    coverage: '21%',
    coveragePercent: 21,
    postcode: 'S',
    labelSize: 12,
    lat: 53.38,
    lon: -1.4511
  },
  {
    id: 'SA',
    label: 'Swansea',
    firms: '12k',
    coverage: '34%',
    coveragePercent: 34,
    postcode: 'SA',
    labelSize: 15,
    lat: 51.881,
    lon: -4.3386
  },
  {
    id: 'SE',
    label: 'South East London',
    firms: '24k',
    coverage: '28%',
    coveragePercent: 28,
    postcode: 'SE',
    labelSize: 9,
    lat: 51.4638,
    lon: -0.0089
  },
  {
    id: 'SG',
    label: 'Stevenage',
    firms: '30k',
    coverage: '42%',
    coveragePercent: 42,
    postcode: 'SG',
    labelSize: 11,
    lat: 51.9803,
    lon: -0.1229
  },
  {
    id: 'SK',
    label: 'Stockport',
    firms: '42k',
    coverage: '36%',
    coveragePercent: 36,
    postcode: 'SK',
    labelSize: 11,
    lat: 53.311,
    lon: -1.9976
  },
  {
    id: 'SL',
    label: 'Slough',
    firms: '45k',
    coverage: '43%',
    coveragePercent: 43,
    postcode: 'SL',
    labelSize: 10,
    lat: 51.5148,
    lon: -0.6622
  },
  {
    id: 'SM',
    label: 'Sutton',
    firms: '8k',
    coverage: '50%',
    coveragePercent: 50,
    postcode: 'SM',
    labelSize: 8,
    lat: 51.355,
    lon: -0.1865
  },
  {
    id: 'SN',
    label: 'Swindon',
    firms: '11k',
    coverage: '23%',
    coveragePercent: 23,
    postcode: 'SN',
    labelSize: 12,
    lat: 51.469,
    lon: -1.8789
  },
  {
    id: 'SO',
    label: 'Southampton',
    firms: '14k',
    coverage: '30%',
    coveragePercent: 30,
    postcode: 'SO',
    labelSize: 11,
    lat: 50.9859,
    lon: -1.3857
  },
  {
    id: 'SP',
    label: 'Salisbury',
    firms: '17k',
    coverage: '37%',
    coveragePercent: 37,
    postcode: 'SP',
    labelSize: 12,
    lat: 51.0968,
    lon: -1.8344
  },
  {
    id: 'SR',
    label: 'Sunderland',
    firms: '23k',
    coverage: '51%',
    coveragePercent: 51,
    postcode: 'SR',
    labelSize: 9,
    lat: 54.8584,
    lon: -1.3855
  },
  {
    id: 'SS',
    label: 'Southend-on-Sea',
    firms: '26k',
    coverage: '24%',
    coveragePercent: 24,
    postcode: 'SS',
    labelSize: 10,
    lat: 51.5693,
    lon: 0.6244
  },
  {
    id: 'ST',
    label: 'Stoke-on-Trent',
    firms: '29k',
    coverage: '31%',
    coveragePercent: 31,
    postcode: 'ST',
    labelSize: 11,
    lat: 52.9365,
    lon: -2.1025
  },
  {
    id: 'SW',
    label: 'South West London',
    firms: '38k',
    coverage: '18%',
    coveragePercent: 18,
    postcode: 'SW',
    labelSize: 9,
    lat: 51.4521,
    lon: -0.1827
  },
  {
    id: 'SY',
    label: 'Shrewsbury',
    firms: '44k',
    coverage: '32%',
    coveragePercent: 32,
    postcode: 'SY',
    labelSize: 15,
    lat: 52.5913,
    lon: -3.2791
  },
  {
    id: 'TA',
    label: 'Taunton',
    firms: '15k',
    coverage: '41%',
    coveragePercent: 41,
    postcode: 'TA',
    labelSize: 13,
    lat: 51.0623,
    lon: -3.1539
  },
  {
    id: 'TD',
    label: 'Galashiels',
    firms: '24k',
    coverage: '28%',
    coveragePercent: 28,
    postcode: 'TD',
    labelSize: 14,
    lat: 55.5712,
    lon: -2.6088
  },
  {
    id: 'TF',
    label: 'Telford',
    firms: '30k',
    coverage: '42%',
    coveragePercent: 42,
    postcode: 'TF',
    labelSize: 11,
    lat: 52.7455,
    lon: -2.4711
  },
  {
    id: 'TN',
    label: 'Tonbridge',
    firms: '14k',
    coverage: '30%',
    coveragePercent: 30,
    postcode: 'TN',
    labelSize: 12,
    lat: 51.0819,
    lon: 0.4826
  },
  {
    id: 'TQ',
    label: 'Torquay',
    firms: '23k',
    coverage: '51%',
    coveragePercent: 51,
    postcode: 'TQ',
    labelSize: 11,
    lat: 50.4623,
    lon: -3.7238
  },
  {
    id: 'TR',
    label: 'Truro',
    firms: '26k',
    coverage: '24%',
    coveragePercent: 24,
    postcode: 'TR',
    labelSize: 12,
    lat: 50.21,
    lon: -5.2071
  },
  {
    id: 'TS',
    label: 'Cleveland',
    firms: '29k',
    coverage: '31%',
    coveragePercent: 31,
    postcode: 'TS',
    labelSize: 11,
    lat: 54.5566,
    lon: -1.2018
  },
  {
    id: 'TW',
    label: 'Twickenham',
    firms: '41k',
    coverage: '25%',
    coveragePercent: 25,
    postcode: 'TW',
    labelSize: 9,
    lat: 51.4442,
    lon: -0.421
  },
  {
    id: 'UB',
    label: 'Southall',
    firms: '21k',
    coverage: '21%',
    coveragePercent: 21,
    postcode: 'UB',
    labelSize: 9,
    lat: 51.54,
    lon: -0.437
  },
  {
    id: 'W',
    label: 'West London',
    firms: '29k',
    coverage: '49%',
    coveragePercent: 49,
    postcode: 'W',
    labelSize: 9,
    lat: 51.5095,
    lon: -0.2448
  },
  {
    id: 'WA',
    label: 'Warrington',
    firms: '24k',
    coverage: '28%',
    coveragePercent: 28,
    postcode: 'WA',
    labelSize: 10,
    lat: 53.367,
    lon: -2.5738
  },
  {
    id: 'WC',
    label: 'Western Central London',
    firms: '30k',
    coverage: '42%',
    coveragePercent: 42,
    postcode: 'WC',
    labelSize: 8,
    lat: 51.522,
    lon: -0.12
  },
  {
    id: 'WD',
    label: 'Watford',
    firms: '33k',
    coverage: '49%',
    coveragePercent: 49,
    postcode: 'WD',
    labelSize: 9,
    lat: 51.6677,
    lon: -0.4079
  },
  {
    id: 'WF',
    label: 'Wakefield',
    firms: '39k',
    coverage: '29%',
    coveragePercent: 29,
    postcode: 'WF',
    labelSize: 10,
    lat: 53.6751,
    lon: -1.4419
  },
  {
    id: 'WN',
    label: 'Wigan',
    firms: '23k',
    coverage: '51%',
    coveragePercent: 51,
    postcode: 'WN',
    labelSize: 9,
    lat: 53.5438,
    lon: -2.6608
  },
  {
    id: 'WR',
    label: 'Worcester',
    firms: '35k',
    coverage: '45%',
    coveragePercent: 45,
    postcode: 'WR',
    labelSize: 11,
    lat: 52.1685,
    lon: -2.2084
  },
  {
    id: 'WS',
    label: 'Walsall',
    firms: '38k',
    coverage: '18%',
    coveragePercent: 18,
    postcode: 'WS',
    labelSize: 10,
    lat: 52.6927,
    lon: -1.9087
  },
  {
    id: 'WV',
    label: 'Wolverhampton',
    firms: '47k',
    coverage: '39%',
    coveragePercent: 39,
    postcode: 'WV',
    labelSize: 10,
    lat: 52.5541,
    lon: -2.3134
  },
  {
    id: 'YO',
    label: 'York',
    firms: '32k',
    coverage: '38%',
    coveragePercent: 38,
    postcode: 'YO',
    labelSize: 14,
    lat: 54.1231,
    lon: -0.828
  },
  {
    id: 'ZE',
    label: 'Lerwick',
    firms: '45k',
    coverage: '43%',
    coveragePercent: 43,
    postcode: 'ZE',
    labelSize: 12,
    lat: 60.2891,
    lon: -1.3387
  }
];

export function getUkMapRegionMetric(
  id: string
): UkMapRegionMetric | undefined {
  return UK_MAP_REGION_METRICS.find((region) => region.id === id);
}

/** "41k" → 41000. Mock company totals until the geo API supplies a count. */
export function firmsCount(firms: string) {
  const match = /^([\d.]+)\s*([kmb])?$/i.exec(firms.trim());
  if (!match) return 0;
  const value = Number(match[1]);
  const unit = match[2]?.toLowerCase();
  if (unit === 'k') return Math.round(value * 1000);
  if (unit === 'm') return Math.round(value * 1_000_000);
  if (unit === 'b') return Math.round(value * 1_000_000_000);
  return Math.round(value);
}

export function companyHeatRange(
  regions: UkMapRegionMetric[] = UK_MAP_REGION_METRICS
) {
  const counts = regions.map((region) => firmsCount(region.firms));
  return {
    min: Math.min(...counts),
    max: Math.max(...counts)
  };
}
